import { columnSelectContext } from './columnSelectContext';
/**
 * A consumer that consumes the surrounding ColumnSelectProvider's context.
 */
export const ColumnSelectConsumer = columnSelectContext.Consumer;
